import cn from 'classnames'
import React, { HTMLAttributes, forwardRef } from 'react'

import styles from './IntegrationCard.module.scss'

import CheckIcon from '~assets/icons/check.svg'
import Box from '~lib/ui-kit/Box'
import Button from '~shared/ui/Button'
import Text from '~shared/ui/Text'

interface IntegrationCardProps extends HTMLAttributes<HTMLDivElement> {
  label: string
  icon: React.ReactNode
  submitLabel?: string
  value?: string
  active: boolean
  loading?: boolean
  disabled?: boolean
  onActionClick?: (value?: string) => void
}

function IntegrationCard(
  {
    active,
    icon,
    label,
    submitLabel = active ? 'Disconnect' : 'Connect',
    value,
    loading,
    disabled,
    onActionClick,
    className,
    ...props
  }: IntegrationCardProps,
  ref: React.ForwardedRef<HTMLDivElement>
) {
  const handleOnActionClick = () => {
    onActionClick?.(value)
  }

  return (
    <Box ref={ref} variant="light" borderRadius="md" className={cn(styles.root, className)} {...props}>
      {active && (
        <span className={styles.connectedIcon}>
          <CheckIcon />
        </span>
      )}

      <div className={styles.icon}>{icon}</div>

      <Text as="div" textType="body-md" fontWeight="semibold" textAlign="center">
        {label}
      </Text>

      <Button
        variant={active && !disabled ? 'default' : 'primary'}
        loading={loading}
        disabled={disabled}
        className={styles.actionButton}
        onClick={handleOnActionClick}
      >
        {submitLabel}
      </Button>
    </Box>
  )
}

export default forwardRef<HTMLElement, IntegrationCardProps>(IntegrationCard)
